import { render, staticRenderFns } from "./DownstreamDetail.vue?vue&type=template&id=88184bae"
import script from "./DownstreamDetail.vue?vue&type=script&lang=js"
export * from "./DownstreamDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports